import AbstractView = require("./abstract/AbstractView");
import TabContainer = require("./tab/TabContainer");
import TabItem = require("./tab/TabItem");
import Config = require("../config/Config");
import GoogleAnalyticsService = require("../service/GoogleAnalyticsService");


class CoolingView extends AbstractView {

    constructor(template: JQuery) {
        super(template);
    }


    init(): void {
        this.itemId = 0;
        this.createTabNav();
        this.createTab();
    }


    resize(): void {
        if (this.$tabNav) {
            let btnOffsetX: number = this.tabNavBtns[this.itemId].offset().left;
            let targetX: number = this.$tabNav.scrollLeft() + btnOffsetX - 20;
            this.$tabNav.scrollLeft(targetX);
        }
        if (this.tabCon) this.tabCon.resize();
    }

    /*
    * Tab
    * */
    private tabCon: TabContainer;
    private tabItemData: any[];

    private createTab(): void {
        this.tabItemData = [
            {selector: "overview", class: TabItem, direction: "Row", video: false},
            {selector: "loop", class: TabItem, direction: "Row", video: true},
            {selector: "spreader", class: TabItem, direction: "Row", video: false},
            {selector: "fans", class: TabItem, direction: "Reverse", video: true},
            {selector: "db0", class: TabItem, direction: "Row", video: false}
        ];

        let tmpArr: any[] = [];
        let itemTotal: number = this.tabItemData.length;
        for (let i: number = 0; i < itemTotal; i++) {

            let className: string = "." + this.tabItemData[i]["selector"] + "-item";
            let itemClass: any = this.tabItemData[i]["class"];
            let item: any = new itemClass(this.$template.find(className));
            item.direction = this.tabItemData[i]["direction"];
            item.createContent();
            if (this.tabItemData[i]["video"]) item.createVideo();

            tmpArr.push(item);
        }

        this.tabCon = new TabContainer(this.$template.find(".tabCon"));
        this.tabCon.setItems(tmpArr);
        this.tabCon.changeTabItem(this.itemId);
    }


    /*
    * TabNav
    * */
    private itemId: number;
    private $tabNavOuter: JQuery;
    private $tabNav: JQuery;
    private tabNavBtns: JQuery[];
    private navTrackingCode: any[];

    private createTabNav(): void {

        this.navTrackingCode = [
            {category: "Tabs", action: "clicked", label: "matrix2080ti-cooling-overview"},
            {category: "Tabs", action: "clicked", label: "matrix2080ti-cooling-overview-infinity-loop-cooling"},
            {category: "Tabs", action: "clicked", label: "matrix2080ti-cooling-overview-extra-large-heat-spreader"},
            {category: "Tabs", action: "clicked", label: "matrix2080ti-cooling-overview-axial-tech-fans"},
            {category: "Tabs", action: "clicked", label: "matrix2080ti-cooling-overview-0db"}
        ];

        this.$tabNavOuter = this.$template.find(".tabnavCon");
        this.$tabNav = this.$template.find(".tabnav");

        this.tabNavBtns = [];
        let btnTotal: number = this.$tabNav.find(".tabnav-item").length;
        for (let i: number = 0; i < btnTotal; i++) {
            let $navBtn: JQuery = this.$tabNav.find(".tabnav-item:eq(" + i + ")").find(".tabnav-link");
            this.tabNavBtns.push($navBtn);

            $navBtn.on("rollover mouseenter", {id: i}, (event: JQueryEventObject) => {
                event.preventDefault();
                if (Config.checkMobileDevice()) return;
                $(event.currentTarget).find(".text").addClass("isover");
            });
            $navBtn.on("rollout mouseleave", {id: i}, (event: JQueryEventObject) => {
                event.preventDefault();
                if (Config.checkMobileDevice()) return;
                $(event.currentTarget).find(".text").removeClass("isover");
            });
            $navBtn.on("click tap", {id: i}, (event: JQueryEventObject) => {
                event.preventDefault();
                // @ts-ignore
                this.itemId = event.data["id"];
                this.tabCon.changeTabItem(this.itemId);
                this.changeNavStatus(this.itemId);
                this.scrollNavCon(this.itemId);

                GoogleAnalyticsService.instance().sendTracking(
                    'event',
                    this.navTrackingCode[i]["category"],
                    this.navTrackingCode[i]["action"],
                    this.navTrackingCode[i]["label"]
                )
            });
        }
        this.changeNavStatus(this.itemId);
    }

    private changeNavStatus(id: number): void {

        for (let i: number = 0; i < this.tabNavBtns.length; i++) {
            let targetBtn: JQuery = <JQuery>this.tabNavBtns[i];
            if (i == id) {
                targetBtn.addClass("active");
            } else {
                targetBtn.removeClass("active");
            }
        }
    }

    private scrollNavCon(id: number): void {

        let btnOffsetX: number = this.tabNavBtns[id].offset().left;
        let targetX: number = this.$tabNav.scrollLeft() + btnOffsetX - 20;
        this.$tabNav.animate({
            scrollLeft: targetX
        }, 700);
    }


    onTransitionComplete(type: string, id?: number): void {
        if (type == AbstractView.Events.ON_TRANSITION_IN_COMPLETE) {
            if (this.tabCon) this.tabCon.transitionIn();
        }
        if (type == AbstractView.Events.ON_TRANSITION_OUT_COMPLETE) {

        }
        super.onTransitionComplete(type, id);
    }
}

export = CoolingView;